import React from 'react';
import PropTypes from 'prop-types';

import themeable from 'zignal-landscape/lib/themeable';

const MenuBulkActions = ({styles, bulkActionsOptions}) => {
  return (
    <ul className={styles.MenuBulkActions}>
      {bulkActionsOptions.map(({ id, icon, onClick, text, cyData }) => {
        return (
          <li key={id} className={styles.bulkOption} onClick={onClick}>
            <a data-cy={cyData} id={id} className={styles.bulkOptionAnchor}>
              <div className={styles.bulkActionIcon}>{icon}</div>
              {text}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

MenuBulkActions.propTypes = {
  styles: PropTypes.object,
  bulkActionsOptions: PropTypes.array
};

export default themeable(MenuBulkActions);
